import type { PhoneMaskMap } from "./types.ts";

export const phoneMaskMap: PhoneMaskMap = {
  US: "(999) 999-9999",
  CA: "(999) 999-9999",
  UNK: "999999999999",
};

export const US = "US";
